import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { bannerAdInteraction, initbannerAdUT, registClickEvent } from './bannerad_ut';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './index.scss';
import { glassboxCustomEvent } from '../../utils/glassbox';
import { useWindowSize } from '../../CommonHooks';

const getGlassboxEventName = ({ campaignId, url, bannerName }) => {
    if (campaignId.includes('BWHO') || url.includes('BWHO') || bannerName.includes('BWHO')) {
        return 'Banner_on_Home';
    }
    if (campaignId.includes('BWRH') || url.includes('BWRH') || bannerName.includes('BWRH')) {
        return 'Banner_on_Racing';
    }
    if (campaignId.includes('BWFH') || url.includes('BWFH') || bannerName.includes('BWFH')) {
        return 'Banner_on_Football';
    }
    if (campaignId.includes('BW6H') || url.includes('BW6H') || bannerName.includes('BW6H')) {
        return 'Banner_on_Marksix';
    }
};

const getGlassboxEventValue = (campaignID, lang) => {
    return campaignID + '_' + lang;
    /*
    if (campaignID.includes('BWHO')) {
        return 'BWHOTB' + parseInt(bannerName.replace('home', '')) + lang;
    }
    if (campaignID.includes('BWRH')) {
        return 'BWRHTB' + parseInt(bannerName.replace('racing', '')) + lang;
    }
    if (campaignID.includes('BWFH')) {
        return 'BWFHTB' + parseInt(bannerName.replace('football', '')) + lang;
    }
    if (campaignID.includes('BW6H')) {
        return 'BW6HTB' + parseInt(bannerName.replace('marksix', '')) + lang;
    }
    */
};

// ref: https://swiperjs.com/swiper-api#param-loop
const minNumOfSlides = 3 + 1 + 1;

export const Swipe = (props) => {
    let { bannerArr = [], autoPlayTime } = props;
    const [activeIndex, setActiveIndex] = useState(0);
    const swiperRef = useRef();

    // WORKAROUND: concat the bannerArr to until its length >= minNumOfSlides, due to Swiper v12 loop restrictions, see https://swiperjs.com/swiper-api#param-loop
    const originalBannerArrLength = bannerArr.length;
    if (bannerArr.length > 0 && bannerArr.length < minNumOfSlides) {
        bannerArr = Array(Math.ceil(minNumOfSlides / bannerArr.length))
            .fill(bannerArr)
            .flat();
    }

    const autoTime = (autoPlayTime || 15) * 1000;

    const { i18n } = useTranslation();
    let lang = i18n.language === 'ch' ? 'C' : 'E';

    const { isMobileSize } = useWindowSize();

    useEffect(() => {
        if (bannerArr.length > 0) {
            const interval = initbannerAdUT();
            bannerAdInteraction(bannerArr[0].bannerScid, i18n.language === 'ch' ? 'zh-hk' : 'en-us');
            registClickEvent();

            return () => clearInterval(interval);
        }
    }, [bannerArr, i18n.language]);

    return (
        <div className="swiper-container">
            <Swiper
                // Swiper some times will not re-render according to state change. Adding key here to force it to re-render
                key={`${JSON.stringify(bannerArr.map((item) => item.bannerScid))} - ${isMobileSize}`}
                slidesPerView={'auto'}
                centeredSlides={true}
                spaceBetween={8}
                autoplay={{
                    delay: autoTime,
                    disableOnInteraction: false
                }}
                style={{
                    '--swiper-navigation-color': '#000',
                    '--swiper-navigation-size': '13px'
                }}
                navigation={isMobileSize ? false : true}
                loop={bannerArr.length > 0}
                modules={[Navigation, Autoplay]}
                className="swiper-custom"
                onRealIndexChange={(swiper) => {
                    setActiveIndex(swiper.realIndex % originalBannerArrLength);

                    // subsequence tracking when change slides
                    if (swiper.slides.length > 1) {
                        bannerAdInteraction(
                            swiper.slides[swiper.realIndex]?.attributes['data-scid'].value,
                            i18n.language === 'ch' ? 'zh-hk' : 'en-us'
                        );
                    }
                }}
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
            >
                {bannerArr.map((item, index) => {
                    // required by bannerad_ut.js
                    const slideProps = {
                            'data-scid': item.bannerScid,
                            'data-url': item.function?.jsFlag === '1' ? item.function.jsUrl : item.url,
                            'data-target': item.function?.jsFlag === '1' ? item.function.jsParam1 : item.target,
                            className: 'bannerAdClick'
                        };

                    return (
                        <SwiperSlide key={index} {...slideProps}>
                            <div
                                onClick={() => {
                                    if (item.function?.jsFlag === '1') {
                                        if (item.function.jsUrl) {
                                            window.open(
                                                item.function.jsUrl,
                                                item.function.jsParam1,
                                                `width=${item.function.jsWidth},height=${item.function.jsHeight}`
                                            );
                                        }
                                    } else {
                                        if (item.url) {
                                            window.open(item.url, item.target, item.targetWindowParameters);
                                        }
                                    }

                                    glassboxCustomEvent(
                                        getGlassboxEventName(item),
                                        getGlassboxEventValue(item.campaignId, lang)
                                    );
                                }}
                                className={`swiper-slide-content`}
                                key={index}
                            >
                                <img src={item.imagePathLarge} alt="" />
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            {/* WORKAROUND: implement our own pagination such that the no. of bullets shown will be based on the original no. of banners, instead of including duplicated banners */}
            <div className="bannerPagination">
                {Array.from({ length: originalBannerArrLength }).map((_, idx) => (
                    <span
                        key={idx}
                        className={`swiper-pagination-bullet ${idx === activeIndex ? 'swiper-pagination-bullet-active' : ''}`}
                        onClick={() => swiperRef.current?.slideToLoop(idx)}
                    />
                ))}
            </div>
        </div>
    );
};
